import { DateFormat } from 'lu-services';

export class LuDatetimePickerService {
	constructor(private readonly datetimePickerComponent: any) {}

	/**
	 * Keys promoted to the top-level object to allow real-time updates
	 */
	private readonly directAccessedKeys = ['disabled', 'readonly'];

	getDatetimeFormat(rubyDateFormat?: string): string {
		switch (rubyDateFormat) {
			case DateFormat.DAY_MONTH_YEAR:
				return 'dd/MM/y H:mm:ss';
			case DateFormat.YEAR_MONTH_DAY:
				return 'y/MM/dd H:mm:ss';
			default:
				return 'MM/dd/y H:mm:ss';
		}
	}

	changeOption(key: string, value: any): void {
		this.datetimePickerComponent.options[key] = value;
		if (this.directAccessedKeys.includes(key)) this.datetimePickerComponent[key] = value;
	}
}
